import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 * Experiment abtest8_web_newvehicle_call_logged_in
 */
export default class GetLoginUrlWithLeadPhoneCallUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {GetSearchUrlService} deps.service
   * @param {GetLoginUrlWithQueryParamsService} deps.service
   */

  constructor({config, getCurrentUserService, getCurrentUrlService, getLoginUrlWithQueryParamsService}) {
    super({config})
    this._config = config
    this._getCurrentUserService = getCurrentUserService
    this._getCurrentUrlService = getCurrentUrlService
    this._getLoginUrlWithQueryParamsService = getLoginUrlWithQueryParamsService
    this._phoneCallQueryParam = this._config.get('search').PHONE_CALL_QUERY_PARAM
  }

  /**
   * @param {Object} params
   * @param {Object} data.search
   * @return {Promise<Object, Error>} alert entity object
   */
  async execute() {
    const currentUser = await this._getCurrentUserService.execute()
    if (currentUser) {
      return Promise.resolve(currentUser.getId())
    }

    const [getCurrentUrlServiceError, currentUrlVO] = await this._getCurrentUrlService.execute()
    if (getCurrentUrlServiceError) {
      return Promise.reject(getCurrentUrlServiceError)
    }

    if (!currentUrlVO.getUrl()) return null

    const queryParams = {
      [this._phoneCallQueryParam]: true
    }

    return this._getLoginUrlWithQueryParamsService
      .execute({url: currentUrlVO.getUrl(), queryParams})
      .then(loginUrlVO => {
        const {url: loginUrl} = loginUrlVO.toJSON() || {}
        return {
          url: loginUrl && decodeURIComponent(loginUrl)
        }
      })
  }
}
